<template>
  <div class="detail-padding out_box">
    <div class="common-card is-border card_l">
      <LeftList ref="LeftList"></LeftList>
    </div>
    <div class="common-card is-border card_r">
      <div class="title">
        <img
          src="@/assets/image/exchange/icon@2x.png"
          style="width:0.3rem;height:0.3rem;margin-right:0.08rem;"
        />
        <span>Stake REP</span>
      </div>
      <div class="all">
        <div class="des">
          Become a <span class="lv-color">Super Validator</span> to get more
          rewards.
        </div>
        <div class="balance">
          Balance : <big-number :number="TATbalance" /> REP
        </div>
        <div class="tat_box">
          <div class="tat_input">
            <img
              src="@/assets/image/exchange/tat1.png"
              style="width:0.36rem;height:0.36rem;margin-right:0.08rem;"
            />
            <b>REP</b>
            <el-input
              class="exchange-input"
              v-model="tatVal"
              placeholder="0.00"
            ></el-input>
          </div>
          <div class="des">Please enter the amount you want to stake</div>
        </div>

        <div class="text_box">
          <p>Note:</p>
          <p>1.At least 1 REP staked, and your staked REP will be burned;</p>
          <p>
            2.Each round is 5 minutes, and your staked REP is only valid
            &nbsp;&nbsp;&nbsp;&nbsp;within these 5 minutes;
          </p>
          <p>
            3.If you want to participate in the next round, please stake again;
          </p>
          <p>
            4.The more staked REP, the greater the chance of being an
            &nbsp;&nbsp;&nbsp;&nbsp;ActiveValidator.
          </p>
        </div>
        <el-button class="btn" @click="handleSubmit">Submit</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { toBigNum, toBigItem, toSmallNum } from "@/utils/bigNumberTran.js";
import LeftList from "./list.vue";
export default {
  components: { LeftList },
  data() {
    return {
      loading: false,
      queryParams: {
        total: 0,
        page: 1,
        pageSize: 10
      },
      tableList: [],
      tatVal: undefined,
      TATbalance: undefined
    };
  },
  created() {
    // this.getList();
    this.contractBid = this.$store.getters.contractMap["contractBid"].contract;
    this.contractBidAddress = this.$store.getters.contractMap[
      "contractBid"
    ].address;
    this.contractTAT = this.$store.getters.contractMap["contractTAT"].contract;
    this.contractTATAddress = this.$store.getters.contractMap[
      "contractTAT"
    ].address;

    if (this.getToken()) {
      this.getTATBalance();
    } else {
      this.$message.warning(
        "You must sign in to the wallet to view this page!"
      );
    }
  },
  computed: {
    account() {
      return this.$store.getters.metaMaskObj.account;
    }
  },
  watch: {
    account: {
      handler(val) {
        if (val) {
          if (this.getToken()) {
            this.getTATBalance();
          }
        }
      }
    }
  },
  methods: {
    async getTATBalance() {
      console.log(this.$store.getters.metaMaskObj.account);
      try {
        this.TATbalance = await this.contractTAT.methods["balanceOf"](
          this.$store.getters.metaMaskObj.account
        ).call({
          from: this.$store.getters.metaMaskObj.account
        });
        console.log(this.TATbalance);
      } catch (e) {
        console.log(e);
      }
    },
    handleSubmit(row) {
      console.dir(this.blocknum);
      if (this.getToken()) {
        let TATbalanceStr = this.BIGNUM.toSmallNumStr2(this.TATbalance);
        let reg = /^(?=.*[1-9])\d{1,17}(?:\.\d{0,18})?$/;
        if (reg.test(this.tatVal)) {
          console.log(this.tatVal, TATbalanceStr);
          if (this.tatVal < 1) {
            this.$message.warning("The REP value must be greater than 1");
            return;
          }
          if (Number(this.tatVal) > Number(TATbalanceStr)) {
            this.$message.warning(
              `REP value cannot be greater than ${TATbalanceStr}`
            );
            return;
          }
        } else {
          this.$message.warning("The REP value must be a numeric type value");
          return;
        }
        const tx_builder = this.contractBid.methods["bidTAT"](
          toBigNum(this.tatVal)
        );
        const encoded_tx = tx_builder.encodeABI();

        let json = {
          gas: this.$store.getters.gas,
          from: this.$store.getters.metaMaskObj.account,
          to: this.contractBidAddress,
          value: 0,
          data: encoded_tx
        };
        web3.eth
          .sendTransaction(json)
          .then(res => {
            this.tatVal = undefined;
            this.getTATBalance();
            this.$refs.LeftList.getData();
            this.$message.success("Successfully staked Rep！");
          })
          .catch(error => {
            console.error(error);
            if (error.code === 4001) {
              this.$message.error(error.message);
            }
          });
      } else {
        this.$message.warning(
          "You must sign in to the wallet to view this page!"
        );
      }
    }
  }
};
</script>
<style scoped lang="scss">
.common-card {
  // background: linear-gradient(90deg, #020202 0%, #020202 42%, #00266B 100%);
}
.out_box {
  display: flex;
  justify-content: space-between;

  .title {
    font-size: 0.32rem;
    font-family: Roboto-Medium, Roboto;
    font-weight: 500;
    color: #fff;
    height: 1.04rem;
    display: flex;
    align-items: center;
    border-bottom: #929dad solid 1px;
    justify-content: center;
  }

  .all {
    padding: 0 0.4rem 0.4rem;
  }

  .card_l {
    width: 60.5%;
    // background: linear-gradient(180deg, #F5F5F5 0%, #F5F5F5 0%, #FAFAFA 56%, #FFFFFF 100%);
    box-shadow: 0px 16px 40px 0px rgba(6, 16, 32, 0.1);
  }

  .card_r {
    width: 38.5%;
    // background: linear-gradient(180deg, #F5F5F5 0%, #F5F5F5 0%, #FAFAFA 56%, #FFFFFF 100%);
    box-shadow: 0px 16px 40px 0px rgba(6, 16, 32, 0.1);
    // padding: 0.4rem;
    box-sizing: border-box;

    .des {
      margin-top: 0.32rem;
      font-size: 0.2rem;
      font-family: Roboto-Regular, Roboto;
      font-weight: 400;
      color: #929dad;
      line-height: 0.32rem;
    }

    .tat_box {
      width: 100%;
      // height: 1.16rem;
      margin-top: 0.1rem;
      padding: 0.16rem 0.24rem;
      box-sizing: border-box;
      border: solid 1px #56627a;
      border-radius: 0.08rem;
      color: #ffffff;
      .tat_input {
        display: flex;
        align-items: center;
        font-size: 0.2rem;
      }
    }

    .balance {
      font-size: 0.2rem;
      font-family: Roboto-Regular, Roboto;
      font-weight: 400;
      color: #56627a;
      line-height: 0.24rem;
      text-align: right;
      margin-top: 0.42rem;
      padding-right: 0.05rem;
    }

    .text_box {
      margin-top: 1rem;
      font-size: 0.18rem;
      font-family: Roboto-Regular, Roboto;
      font-weight: 400;
      color: #929dad;
      line-height: 0.32rem;
      text-align: justify;

      p {
        margin: 0;
        letter-spacing: -0.5px;
      }
    }
  }
}

.exchange-input {
  ::v-deep  .el-input__inner {
    border: none;
    text-align: right;
    font-size: 0.3rem;
    font-weight: 500;
    height: 0.3rem;
    color: #fff;
    padding: 0 0;
    background: transparent;
    font-family: DMSans-Medium;
  }
}
.el-message--warning {
  background-color: linear-gradient(to right, #020202, #001a49) !important;
  color: #1f1f1f !important;
}
.btn {
  margin-top: 0.4rem;
  width: 100%;
  height: 0.72rem;
  background: linear-gradient(264deg, #225bfc 0%, #062567 100%);
  font-size: 0.24rem;
  font-family: Roboto-Medium, Roboto;
  font-weight: 500;
  color: #ffffff;
  // cursor: pointer;
  border: none;
}
.lv-color {
  color: #38f4ba;
}
</style>
